import { useMemo } from 'react';

import {
  useRetailerNetworkHighestRoleUserSelector,
  useUserSelector,
} from '@occc-app/App/AppContext';
import { Retailer_Network_User_Role, User_Role } from '@occc/graphql';

export const useRetailerConnectUser = () => {
  const user = useUserSelector();
  const retailerNetworkUser = useRetailerNetworkHighestRoleUserSelector();

  const isRetailerConnectUserRole = user?.userRole === User_Role.RcUser;

  const isRetailerNetworkUserRole =
    isRetailerConnectUserRole &&
    (retailerNetworkUser?.role === Retailer_Network_User_Role.RetailerNetworkAdmin ||
      retailerNetworkUser?.role === Retailer_Network_User_Role.RetailerNetworkUser);

  const isRetailerNetworkSiteUserRole =
    isRetailerConnectUserRole &&
    (retailerNetworkUser?.role === Retailer_Network_User_Role.SiteAdmin ||
      retailerNetworkUser?.role === Retailer_Network_User_Role.SiteUser);

  return useMemo(
    () => ({
      userId: user?.uuid || retailerNetworkUser?.openCommerceUser?.uuid,
      userRole: user?.userRole,
      userName: user?.name || retailerNetworkUser?.openCommerceUser?.name,
      userEmail: user?.email || retailerNetworkUser?.openCommerceUser?.email,
      retailerNetworkUserId: retailerNetworkUser?.uuid,
      retailerNetworkId: retailerNetworkUser?.retailerNetwork?.uuid,
      retailerNetworkUserRole: retailerNetworkUser?.role,
      isRetailerNetworkUserRole,
      isRetailerNetworkSiteUserRole,
    }),
    [
      user?.uuid,
      user?.userRole,
      user?.name,
      user?.email,
      retailerNetworkUser?.openCommerceUser?.uuid,
      retailerNetworkUser?.openCommerceUser?.name,
      retailerNetworkUser?.openCommerceUser?.email,
      retailerNetworkUser?.uuid,
      retailerNetworkUser?.retailerNetwork?.uuid,
      retailerNetworkUser?.role,
      isRetailerNetworkUserRole,
      isRetailerNetworkSiteUserRole,
    ],
  );
};
